import { t } from '../i18n';
import { Mail, MapPin, Linkedin, ArrowUpRight, ArrowRight, Plus } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const faqs = [
    { q: t("What types of projects do you work on?"), a: t("I specialize in web development, AI integration, and automation projects.") },
    { q: t("What is your typical process?"), a: t("Initial consultation, requirements gathering, proposal, development, testing, and deployment.") },
    { q: t("How do you handle pricing?"), a: t("I offer both hourly rates and fixed-price quotes depending on the project.") },
    { q: t("Do you provide ongoing maintenance?"), a: t("Yes, through retainer agreements or as-needed arrangements.") },
  ];

  return (
    <div className="content-panel contact-page">
      <header className="contact-header">
        <div className="contact-rule" aria-hidden="true" />
        <h1 className="font-display">{t("Get in Touch")}</h1>
        <p>{t("Have a project in mind or want to discuss a potential collaboration?")} {t("I'd love to hear from you!")}</p>
      </header>

      <section className="contact-layout" aria-label={t("Contact Information")}>
        <div className="contact-invitation">
          <Mail className="contact-mail-icon" size={28} strokeWidth={1.4} aria-hidden="true" />
          <h2 className="font-display">{t("Every project starts with a conversation.")}</h2>
          <p className="contact-intro">{t("Tell me what you have in mind, where you are now, and what you would like to build.")}</p>
          <a className="contact-email" href="mailto:contact@virtuoz-solutions.com">
            <span>contact@<wbr />virtuoz-solutions.com</span>
            <ArrowUpRight size={24} aria-hidden="true" />
          </a>
          <div className="contact-action-row">
            <a className="contact-write" href="mailto:contact@virtuoz-solutions.com">
              {t("Write me an email")} <ArrowRight size={18} aria-hidden="true" />
            </a>
            <span>{t("Opens your email app")}</span>
          </div>
        </div>

        <aside className="contact-details">
          <div className="contact-availability">
            <span className="contact-status-dot" aria-hidden="true" />
            <span>{t("Available for new projects")}</span>
          </div>
          <div className="contact-detail-block">
            <h2>{t("A direct conversation")}</h2>
            <p>{t("You will hear directly from me, usually within 24–48 hours.")}</p>
          </div>
          <div className="contact-location"><MapPin size={18} aria-hidden="true" /><span>Angers, France</span></div>
          <div className="contact-social">
            <h2>{t("Elsewhere online")}</h2>
            <a href="https://www.linkedin.com/in/enzo-chevallier-6a69b77b/" target="_blank" rel="noopener noreferrer">
              <Linkedin size={18} aria-hidden="true" /><span>LinkedIn</span><ArrowUpRight size={17} aria-hidden="true" />
            </a>
            <a href="https://x.com/EnzoChevallier" target="_blank" rel="noopener noreferrer">
              <span className="contact-x" aria-hidden="true">𝕏</span><span>X / Twitter</span><ArrowUpRight size={17} aria-hidden="true" />
            </a>
          </div>
        </aside>
      </section>

      <section className="contact-faq" aria-labelledby="contact-faq-title">
        <h2 id="contact-faq-title" className="font-display">{t("Frequently Asked Questions")}</h2>
        <div className="contact-faq-grid">
          {faqs.map((faq) => (
            <details key={faq.q}>
              <summary>{faq.q}<Plus size={18} aria-hidden="true" /></summary>
              <p>{faq.a}</p>
            </details>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Contact;
